import { TableRow, TableCell, Box } from '@mui/material';
import SalesMngCostStatsTableCell from './SalesMngCostStatsTableCell';

const SalesMngCostStatsRow = ({ data, headers }) => {
  if (Array.isArray(data) && data.length === 0) {
    return <Box>데이터가 없습니다.</Box>;
  }

  return (
    data &&
    data.map((account, aIndex) => {
      return (
        <TableRow key={`${aIndex}`}>
          <TableCell align="center" sx={{ width: 200 }}>
            {account.label}
          </TableCell>
          <SalesMngCostStatsTableCell
            data={account?.data}
            headerRows={headers}
          />
        </TableRow>
      );
    })
  );
};

export default SalesMngCostStatsRow;
